
import { BasicController } from "@goodgamestudios/core";

import { int } from "@goodgamestudios/math-utilities";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { Poker2ShopEvent } from "../../event/Poker2ShopEvent";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { StarterPackageItemVO } from "../../gamevo/StarterPackageItemVO";
import { StarterPackageVO } from "../../gamevo/StarterPackageVO";
import { Poker2Model } from "../Poker2Model";

export class Poker2ShopData {
    private _colorTables: Map<any, any>;

    public shopAccessoires: any[];
    public shopBackground: any[];
    public shopBeard: any[];
    public shopBottom: any[];
    public shopEyes: any[];
    public shopGimmicks: any[];
    public shopHair: any[];
    public shopJacket: any[];
    public shopJewelry: any[];
    public shopMouth: any[];
    public shopNose: any[];
    public shopPet: any[];
    public shopShoes: any[];
    public shopSkin: any[];
    public shopTop: any[];
    public shopBoosterChipsXP: any[];
    public shopCostume: any[];
    public shopScreen: any[];

    public femaleItems: any[];
    public maleItems: any[];
    public unisexItems: any[];

    private _femaleTopUnderwear: number = 0;
    private _maleTopUnderwear: number = 0;
    private _femaleBottomUnderwear: number = 0;
    private _maleBottomUnderwear: number = 0;

    public starterPackages: StarterPackageVO[];
    public starterPackagesItemIds: StarterPackageItemVO[];
    public starterPackagesTimeLeft: number = NaN;
    public starterPackageBoughtId: number = NaN;

    constructor() {
        this._colorTables = new Map<any, any>();

        this.shopCostume = new Array;
        this.shopAccessoires = new Array;
        this.shopBackground = new Array;
        this.shopBeard = new Array;
        this.shopBottom = new Array;
        this.shopEyes = new Array;
        this.shopGimmicks = new Array;
        this.shopHair = new Array;
        this.shopJacket = new Array;
        this.shopJewelry = new Array;
        this.shopMouth = new Array;
        this.shopNose = new Array;
        this.shopPet = new Array;
        this.shopShoes = new Array;
        this.shopSkin = new Array;
        this.shopTop = new Array;
        this.shopScreen = new Array;
        this.shopBoosterChipsXP = new Array;
        this.femaleItems = new Array;
        this.maleItems = new Array;
        this.unisexItems = new Array;
    }

    /**
     * Parses starter packages informations after a buy action.
     */
    public parse_spb(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        // store id of the bought package
        this.starterPackageBoughtId = paramObject.id;

        // update starter package data
        var boughtSPVO: StarterPackageVO;
        if (this.starterPackages != null) {
            for (let entryList of this.starterPackages) {
                var vo: any = entryList;
                if (vo === undefined) continue;

                if (this.starterPackageBoughtId == vo.id) {
                    // item has been bought, deactivate it
                    vo.active = false;
                    boughtSPVO = vo;
                }
            }
        }

        // update the view (e.g. disable the bought item)
        this.controller.dispatchEvent(new Poker2ShopEvent("updateStartPackages", [this.starterPackageBoughtId, boughtSPVO]));

        // construct dummy object to use parse_SBU in the same way like buying
        // a single item via the shop
        var boughtItems: any[] = [];
        var innerItem: any[];
        if (boughtSPVO.items && boughtSPVO.items.length > 0) {
            for (let entryList of boughtSPVO.items) {
                var spItem: any = entryList;
                if (spItem === undefined) continue;

                innerItem = [];
                innerItem.push(spItem.id);
                innerItem.push(-1);
                boughtItems.push(innerItem);
            }

            var obj: any = {};
            obj.L = boughtItems;

            // update the avatar view and the inventory, if the package contained items
            Poker2Model.inventoryData.parse_SBU(obj.L);
        }
    }

    /**
     * Parses starter packages informations.
     */
    public parse_sps(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        this.starterPackagesTimeLeft = paramObject.timeleft;
        this.parseStarterPackages(paramObject.S);
    }

    public parseStarterPackages(paramArray: any[]): void {
        // sanity check
        if (!paramArray) {
            return;
        }

        this.starterPackages = [];
        this.starterPackagesItemIds = [];

        if (paramArray != null) {
            for (let entryList of paramArray) {
                var starterPackageData: any = entryList;
                if (starterPackageData === undefined) continue;

                var starterPackageVO: StarterPackageVO = new StarterPackageVO();
                starterPackageVO.id = int(starterPackageData.id);
                starterPackageVO.active = starterPackageData.active;
                starterPackageVO.name = starterPackageData.name;
                starterPackageVO.items = this.parseStarterPackageItems(starterPackageData.SPI);
                starterPackageVO.chips = starterPackageData.chips;
                starterPackageVO.goldCosts = Number(starterPackageData.price_gold);
                starterPackageVO.boosterIds = this.parseStarterPackageBoosterIds(starterPackageData.B);
                this.starterPackages.push(starterPackageVO);
            }
        }
    }

    private parseStarterPackageItems(paramArray: any[]): StarterPackageItemVO[] {
        var items: StarterPackageItemVO[] = [];

        if (paramArray != null) {
            for (let entryList of paramArray) {
                var itemData: any = entryList;
                if (itemData === undefined) continue;

                var starterPackageItemVO: StarterPackageItemVO = new StarterPackageItemVO();
                starterPackageItemVO.id = int(itemData.id);
                items.push(starterPackageItemVO);
                this.starterPackagesItemIds.push(starterPackageItemVO);
            }
        }

        return items;
    }

    private parseStarterPackageBoosterIds(paramArray: any[]): number[] {
        var booster: number[] = [];

        if (paramArray != null) {
            for (let entryList of paramArray) {
                var boosterData: any = entryList;
                if (boosterData === undefined) continue;

                booster.push(boosterData);
            }
        }

        return booster;
    }

    public buildShop(voList: Map<any, any>): void {
        if (voList != null) {
            for (let entryList of Array.from(voList.values())) {
                var element: any = entryList;
                if (element === undefined) { continue; }

                if (instanceOfClass(element, "ColorTableVO"))
                    this._colorTables.set(element.id, element);

                if (!(instanceOfClass(element, "ItemsVO")))
                    continue;

                var itemVO: ItemsVO = element as ItemsVO;
                switch (itemVO.sex) {
                    case "male":
                        this.maleItems.push(itemVO);
                        if (itemVO.itemCategory == "underwearBottom")
                            this._maleBottomUnderwear = int(itemVO.id);
                        if (itemVO.itemCategory == "underwearTop")
                            this._maleTopUnderwear = int(itemVO.id);
                        break;
                    case "female":
                        this.femaleItems.push(itemVO);
                        if (itemVO.itemCategory == "underwearBottom")
                            this._femaleBottomUnderwear = int(itemVO.id);
                        if (itemVO.itemCategory == "underwearTop")
                            this._femaleTopUnderwear = int(itemVO.id);
                        break;
                    case "both":
                        this.unisexItems.push(itemVO);
                        break;
                }

                if (itemVO.itemCategory == "underwearBottom" || itemVO.itemCategory == "underwearTop")
                    continue;

                switch (itemVO.shopCategorySecondary) {
                    case "shopCostume":
                        this.shopCostume.push(itemVO);
                        break;
                    case "shopAccessoires":
                        this.shopAccessoires.push(itemVO);
                        break;
                    case "shopBackground":
                        this.shopBackground.push(itemVO);
                        break;
                    case "shopScreen":
                        this.shopScreen.push(itemVO);
                        break;
                    case "shopBeard":
                        this.shopBeard.push(itemVO);
                        break;
                    case "shopBottom":
                        this.shopBottom.push(itemVO);
                        break;
                    case "shopEyes":
                        this.shopEyes.push(itemVO);
                        break;
                    case "shopGimmicks":
                        this.shopGimmicks.push(itemVO);
                        break;
                    case "shopHair":
                        this.shopHair.push(itemVO);
                        break;
                    case "shopJacket":
                        this.shopJacket.push(itemVO);
                        break;
                    case "shopJewelry":
                        this.shopJewelry.push(itemVO);
                        break;
                    case "shopMouth":
                        this.shopMouth.push(itemVO);
                        break;
                    case "shopNose":
                        this.shopNose.push(itemVO);
                        break;
                    case "shopPet":
                        this.shopPet.push(itemVO);
                        break;
                    case "shopShoes":
                        this.shopShoes.push(itemVO);
                        break;
                    case "shopSkin":
                        this.shopSkin.push(itemVO);
                        break;
                    case "shopTop":
                        this.shopTop.push(itemVO);
                        break;
                    case "shopBoosterChipsXP":
                        this.shopBoosterChipsXP.push(itemVO);
                        break;
                }
            }
        }
    }

    public getTopUnderwearIdByGender(gender: string): number {
        if (gender == "male")
            return this._maleTopUnderwear;
        else
            return this._femaleTopUnderwear;
    }

    public getBottomUnderwearIdByGender(gender: string): number {
        if (gender == "male")
            return this._maleBottomUnderwear;
        else
            return this._femaleBottomUnderwear;
    }

    public getItemVObyID(wodId: number): ItemsVO {
        for (var i: number = 0; i < this.maleItems.length; i++) {
            if ((this.maleItems[i] as ItemsVO).id == wodId)
                return VOHelper.clone(this.maleItems[i]) as ItemsVO;
        }
        for (var j: number = 0; j < this.femaleItems.length; j++) {
            if ((this.femaleItems[j] as ItemsVO).id == wodId)
                return VOHelper.clone(this.femaleItems[j]) as ItemsVO;
        }
        for (var k: number = 0; k < this.unisexItems.length; k++) {
            if ((this.unisexItems[k] as ItemsVO).id == wodId)
                return VOHelper.clone(this.unisexItems[k]) as ItemsVO;
        }
        return null;
    }

    public getColorTableByTableId(tableId: number): any[] {
        var result: any[] = new Array();
        if (this._colorTables != null) {
            for (let entryList of Array.from(this._colorTables.values())) {
                var colorTable: any = entryList;
                if (colorTable === undefined) { continue; }

                if (colorTable.colorTable == tableId)
                    result.push(colorTable);
            }
        }
        return result;
    }

    public getColorById(colorId: number): string {
        var result: string;
        if (this._colorTables != null) {
            for (let entryList of Array.from(this._colorTables.values())) {
                var colorTable: any = entryList;
                if (colorTable === undefined) { continue; }

                if (colorTable.id == colorId)
                    result = colorTable.color;
            }
        }
        return "0x" + result;
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }
}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
